import React from 'react';
import { Button } from '@design-system/components/button/button';
import { Input } from '@design-system/components/input/input';
import { Switch } from '@mui/material';
import { bgColorsVars } from '@design-system/vars.css';

type GenerateDescriptionProps = {
  name: string;
  bulletForm: boolean;
  concise: boolean;
  generatedDescription: string;
  onGenerate: () => void;
  onNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onToggleBulletForm: () => void;
  onToggleConcise: () => void;
  onAdd: () => void;
};

export const GenerateDescription = ({
  name,
  bulletForm,
  concise,
  onGenerate,
  onNameChange,
  onToggleBulletForm,
  onToggleConcise,
  generatedDescription,
  onAdd,
}: GenerateDescriptionProps) => {
  return (
    <div
      style={{
        margin: '1px',
        padding: '20px',
        border: 'solid 2px',
        borderColor: bgColorsVars['N-40'],
        borderRadius: 10,
        fontWeight: 500,
        boxSizing: 'border-box',
        minHeight: '64px',
        maxWidth: 750,
      }}
    >
      <b>Admin</b>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <label className="w-32 inline-block">Exercise</label>
        <Input value={name} onChange={onNameChange} />

        <Button
          disabled={name.length < 3}
          color="primaryTonal"
          className="w-[80px] mr-2 text-xs"
          onClick={onGenerate}
        >
          Generate
        </Button>
      </div>

      <div>
        <label className="w-24 inline-block">Bullet form</label>
        <Switch checked={bulletForm} onChange={onToggleBulletForm} />
      </div>
      <div>
        <label className="w-24 inline-block">Concise</label>
        <Switch checked={concise} onChange={onToggleConcise} />
      </div>

      <div style={{ marginTop: 20 }}>
        <label>Description</label>
        <div
          style={{
            margin: '1px',
            padding: '8px 16px',
            border: 'solid 2px',
            borderColor: bgColorsVars['N-40'],
            borderRadius: 10,
            fontWeight: 500,
            boxSizing: 'border-box',
            minHeight: '64px',
          }}
        >
          {bulletForm && generatedDescription
            ? generatedDescription
                .split('\n')
                .map((row) => <p key={row}>{row}</p>)
            : generatedDescription}
        </div>
      </div>

      <div className="flex mt-6 justify-end">
        <Button
          color="primaryTonal"
          className="w-[80px] mr-2 text-xs"
          onClick={onAdd}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};
